import { createSvgIcon } from '@mui/material/utils';

const InfoIcon = createSvgIcon(
    <svg viewBox="0 0 48 48">
        <path d="M20.4584 14.1204V9.44043H27.1784V14.1204H20.4584ZM21.0984 39.0004V22.1204L18.8984 20.2804V17.8404H27.1784V39.0004H21.0984Z" />
    </svg>,
    'Info'
);

export default InfoIcon;
